import React from "react";

const LoaderSpinner = ({
  label = "",
  isFixedCenter,
  isAbsoluteCenter,
}) => (
  <div
    className={`spinner ${isFixedCenter && "spinner--fixed"} ${
      isAbsoluteCenter && "spinner--absolute-center"
    }`}
  >
    <div className="spinner-label">{label}</div>
    <small className="spinner-icon" />
  </div>
);

export default React.memo(LoaderSpinner);
